import { Grid, Stack } from "@mui/material";

import { TemplateManagementConfig } from "./TemplateManagement.types";
import { TemplateEditor } from "./components/TemplateEditor";
import { TemplatePlaceholderPanel } from "./components/TemplatePlaceholderPanel";
import { TemplateSelect } from "./components/TemplateSelect";
import { usePlaceholderInsert } from "./hooks/usePlaceholderInsert";
import { useTemplateManagement } from "./hooks/useTemplateManagement";

interface Props {
  config: TemplateManagementConfig;
}

export function TemplateManagement({ config }: Props) {
  const {
    isCreating,
    templates,
    selectedTemplate,
    formik,
    isSaving,
    isDeleting,
    handleSelectTemplate,
    handleAddNew,
    handleCancelCreate,
    handleDelete,
  } = useTemplateManagement(config);

  const { insertPlaceholder } = usePlaceholderInsert(formik);
  const hasSelection = isCreating || selectedTemplate !== null;

  return (
    <Stack flex={1} minHeight={0} overflow="hidden" gap={2} pt={1}>
      <TemplateSelect
        templates={templates}
        selectedTemplate={selectedTemplate}
        labels={config.labels}
        onSelect={handleSelectTemplate}
        onAddNew={handleAddNew}
      />

      <Grid container spacing={2} sx={{ flexGrow: 1, overflow: "hidden", minHeight: 0 }}>
        <Grid size={8} sx={{ display: "flex", flexDirection: "column", maxHeight: "100%" }}>
          <TemplateEditor
            hasSelection={hasSelection}
            isNew={isCreating}
            formik={formik}
            labels={config.labels}
            titleMaxLength={config.titleMaxLength}
            subject={config.subject}
            isSaving={isSaving}
            isDeleting={isDeleting}
            onDelete={handleDelete}
            onCancel={handleCancelCreate}
          />
        </Grid>
        <Grid size={4} sx={{ display: "flex", flexDirection: "column", maxHeight: "100%" }}>
          <Stack
            flex={1}
            minHeight={0}
            overflow="hidden"
            bgcolor={(theme) => theme.palette.fsw["blue-5"]}
            borderRadius={1}
          >
            <TemplatePlaceholderPanel onInsert={insertPlaceholder} disabled={!hasSelection} />
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
}
